import { useCustomInterestFollow as n } from "./index.es10.js";
import { useNoTagFollow as c } from "./index.es11.js";
import { useRecommendFollow as u } from "./index.es12.js";
const g = (s, t) => {
  const o = n(s, t, !!s.customInterest), e = u(
    s,
    t,
    !!s.tag && !s.customInterest
  ), r = c(s, t, !s.tag && !s.customInterest);
  return {
    ...o ?? e ?? r
  };
};
export {
  g as useFollow
};
//# sourceMappingURL=index.es9.js.map
